import type { Table } from "@tanstack/vue-table";

export const useHandlePageSizeChange = <T>(table: Table<T>) => {
  const handlePageSizeChange = (e: Event) => {
    table.setPageSize(Number((e.target as HTMLInputElement).value));
  };

  return handlePageSizeChange;
};
